import { Controller } from "@hotwired/stimulus"

const WRONG_CODE_REASON = "wrong code";

export default class extends Controller {
  connect() {
    this.status = this.element.querySelector("[name='status']");
    this.checkboxes = this.element.querySelector("#checkboxes");
    this.suggestedCode = this.element.querySelector("[name='suggested_code']");
    this.suggestedCodeError = this.element.querySelector("#suggested-code-error");
    this.publicNote = this.element.querySelector("[name='public_note']");

    this.onStatusChanged();
  }

  onStatusChanged() {
    const isEdited = this.status.value === "edited";
    this.checkboxes.classList.toggle("hidden", !isEdited);
    this.publicNote.classList.toggle("hidden", !isEdited);
    this.refreshSuggestedCodeVisibility();
  }

  onReasonsChanged() {
    this.refreshSuggestedCodeVisibility();
  }

  // suggested_code only makes sense when the reviewer is asserting that the
  // existing code is wrong, so we only show the input (and its inline error
  // slot) when status is "edited" AND "wrong code" is checked. When hidden,
  // we clear the field so a stale value can't sneak through on submit.
  refreshSuggestedCodeVisibility() {
    const isEdited = this.status.value === "edited";
    const wrongCodeBox = this.element.querySelector(
      `input[name='edit_reasons[]'][value='${WRONG_CODE_REASON}']`
    );
    const shouldShow = isEdited && !!wrongCodeBox && wrongCodeBox.checked;

    this.suggestedCode.classList.toggle("hidden", !shouldShow);
    if (this.suggestedCodeError) {
      this.suggestedCodeError.classList.toggle("hidden", !shouldShow);
    }
    if (!shouldShow) {
      this.suggestedCode.value = "";
    }
  }
}